import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Tooltip } from 'udesk-ui';
import { InfoCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const Wrapper = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #999;
`;

export interface TokenEstimateRef {
    update: (text: string) => void;
}

/**
 * Token 预估展示：数量常显，口径说明放在图标悬浮中
 *
 * 独立组件 + ref 直接更新文本：预估更新不会触发 PromptArea 重渲染
 * （其编辑器依赖 key 强制刷新，重渲染会丢失光标）。
 */
const TokenEstimate = forwardRef<TokenEstimateRef>((_props, ref) => {
    const textRef = useRef<HTMLSpanElement>(null);

    useImperativeHandle(
        ref,
        () => ({
            update: (text: string) => {
                if (textRef.current) {
                    textRef.current.textContent = text;
                }
            },
        }),
        []
    );

    return (
        <Wrapper>
            <span ref={textRef} />

            <Tooltip
                // 统计口径（按项目规则暂无对应翻译，中文硬编码）
                // no-locale-translate
                title={
                    // 默认 nowrap 会把长文案截断，这里限制宽度并强制换行
                    <div style={{ maxWidth: 300, whiteSpace: 'normal', wordBreak: 'break-word' }}>
                        提示语 + 输出规范 + 系统固定开销，不含运行时注入的对话数据
                    </div>
                }
            >
                <InfoCircleOutlined style={{ cursor: 'pointer' }} />
            </Tooltip>
        </Wrapper>
    );
});

export default TokenEstimate;
